import { ImageLibrary } from "./ImageLibrary";

export const goalArray = [
  {
    id: 1,
    Title: "Protection",
    description:
      "Ensure financial security for your family in case of unforeseen events.",
    goalSVG: ImageLibrary.PROTECTION,
  },
  {
    id: 2,
    Title: "Child’s education",
    description: "Plan ahead to fund your child’s education at every stage.",
    goalSVG: ImageLibrary.CHILD_EDUCATION,
  },
  {
    id: 2,
    Title: "Child's Wedding Fund",
    description: "Save gradually to cover your child’s wedding expenses.",
    goalSVG: ImageLibrary.CHILD_WEDDING,
  },
  {
    id: 4,
    Title: "Investment",
    description: "Grow your wealth over time through smart financial planning.",
    goalSVG: ImageLibrary.INVESTMENT,
  },
  {
    id: 5,
    Title: "Retirement",
    description:
      "Helps maintain your lifestyle after your regular income stops.",
    goalSVG: ImageLibrary.RETIREMENT,
  },
];
